import type { PropsWithChildren, ReactNode } from "react";
import { Text } from "@corpuscomplete/web-ui/components/text";
import { cn } from "@corpuscomplete/web-ui/lib/utils";

export function RecipePageSection({
  title,
  description,
  className,
  children,
}: PropsWithChildren<{
  title: string;
  description?: ReactNode;
  className?: string;
}>) {
  return (
    <section className={cn("flex flex-col gap-4", className)}>
      <div className="flex flex-col gap-1">
        <Text variant="h4">{title}</Text>
        {description ? (
          <Text variant="xs" className="text-muted-foreground">
            {description}
          </Text>
        ) : null}
      </div>
      {children}
    </section>
  );
}

export function RecipeMetric({
  label,
  value,
  className,
}: {
  label: string;
  value: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("flex flex-col gap-1", className)}>
      <Text variant="xs" className="text-muted-foreground">
        {label}
      </Text>
      <Text variant="sm" className="font-medium">
        {value}
      </Text>
    </div>
  );
}

export function RecipeStepNumber({ children }: PropsWithChildren) {
  return (
    <div className="flex size-7 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
      <Text variant="sm" className="font-medium text-inherit">
        {children}
      </Text>
    </div>
  );
}
